<script setup>
import ActivityStockPriceLine from '@/components/activity/ActivityStockPriceLine'
import ActivityDetailsCard from '@/components/activity/ActivityDetailsCard.vue'
import { getSkillsetMatchVersion } from '../SkillsetMatch/services'
import { asyncComputed } from '@/utils/asyncComputed'
import { computed } from 'vue'
import ProfileSection from '../shared/profile-section.vue'

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const version = asyncComputed(() => getSkillsetMatchVersion(props.item.details.versionId))

const summary = computed(() => {
    if (!version.value) {
        return null
    }

    const all = [...version.value.news, ...version.value.issuesAndOpportunities]

    const summary = {}
    all.forEach(i => (summary[i.evaluation] = (summary[i.evaluation] ?? 0) + 1))
    return summary
})
</script>
<template>
    <ActivityDetailsCard
        activityType="Execution Update"
        :title="item.description"
        :entity="item.entity"
        class="execution-update-details"
    >
        <template #sub-header v-if="version">
            <div class="cell wide">
                <h5>Company</h5>
                <span>{{ version.company.name }}</span>
            </div>
            <div class="cell">
                <h5>Ticker</h5>
                <span>{{ version.company.symbol }}</span>
            </div>
            <div class="cell">
                <h5>Date</h5>
                <span>{{ new Date(version.createdDate).toLocaleDateString() }}</span>
            </div>
            <div class="cell wide">
                <h5>Reason</h5>
                <span>{{ version.reason }}</span>
            </div>
        </template>
        <ProfileSection title="Execution Update" v-if="summary">
            <template #view-all>
                <router-link
                    class="primary"
                    :to="{
                        name: 'company-page',
                        params: { id: version.company.id },
                    }"
                >
                    View Details
                </router-link>
            </template>
            <table class="mt-table">
                <tr>
                    <th>Negative</th>
                    <td>{{ summary.Negative ?? 0 }}</td>
                </tr>
                <tr>
                    <th>Neutral</th>
                    <td>{{ summary.Neutral ?? 0 }}</td>
                </tr>
                <tr>
                    <th>Positive</th>
                    <td>{{ summary.Positive ?? 0 }}</td>
                </tr>
            </table>
        </ProfileSection>
        <ActivityStockPriceLine :item="item" />
    </ActivityDetailsCard>
</template>
<style scoped>
.profile-section + .profile-section {
    margin-top: 40px;
}

.mt-table td {
    border-bottom: none;
    width: 50%;
}

.mt-table th {
    border-bottom: 1px solid white;
    width: 50%;
}
</style>
